var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pm-structure-form__history"},_vm._l((_vm.history),function(item){return _c('PMChartHistoryItem',{key:item.id,attrs:{"history":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }